import { useCallback } from 'react';
import { useResolvedJql } from '../../services/active-jql/index.tsx';
import { useIssueSearchActions } from '../../services/issue-search/selectors.tsx';

export const useJqlSearch = (changeJql?: (jql: string, clearFilter?: boolean) => void) => {
	const query = useResolvedJql();

	const { refetch } = useIssueSearchActions();

	const onSearch = useCallback(
		(jql: string) => {
			if (jql === query) {
				// This will execute a new search against the network with current JQL input arguments
				refetch();
			} else {
				changeJql && changeJql(jql);
			}
		},
		[query, refetch, changeJql],
	);

	return { onSearch, query };
};
